"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.privilegeExtractor = void 0;
var privilegeExtractor = function (response) { return response.privileges; };
exports.privilegeExtractor = privilegeExtractor;
//# sourceMappingURL=Privilege.consts.js.map